import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useSchoolCalendar from './useSchoolCalendar';
import SchoolCalendarSummaryCard from './SchoolCalendarSummaryCard';
import { useTranslation } from 'react-i18next';

export default function SchoolCalendarSettingsSummary({ schoolYearStart, contextKey }) {
  const { t: tr } = useTranslation();
  const { data, error, refresh } = useSchoolCalendar({ schoolYearStart, contextKey });
  return (
    <div className="mb-3">
      {data && (
        <SchoolCalendarSummaryCard
          calendar={data}
          actions={data.status !== 'updating' && (
            <Link className="btn manage-button manage-teal-button" to={`/manage/settings/school-calendar?schoolYearStart=${schoolYearStart}`}>
              {data.teachingPeriod ? tr("calendar:manageCalendar_159") : tr("manage:extraConfigureCalendar_134")}
            </Link>
          )}
        />
      )}
      {error && (
        <div className="school-calendar-panel">
          <p role="alert">{error.code === 'SCHEDULE_UPDATING' ? tr("calendar:theCalendarIsBeingUpdated_163") : tr("calendar:couldNotLoadTheSchoolCalendar_160")}</p>
          <button type="button" className="manage-teal-button" onClick={refresh}>{tr("manage:tryAgain_183")}</button>
        </div>
      )}
      {!data && !error && <p role="status">{tr("calendar:loadingSchoolCalendar_145")}</p>}
    </div>
  );
}
SchoolCalendarSettingsSummary.propTypes = { schoolYearStart: PropTypes.number.isRequired, contextKey: PropTypes.string.isRequired };
